import { API } from 'aws-amplify';
import axios from 'axios';
import {currentPublicSessionCredentials, getAuthenticatedIdToken, sign} from '../helpr/authHelper';

class Service {
  constructor(apiName) {
    this.apiName = apiName;
  }

  /*
    API actions using the default sig4 signing method
   */
  get = async (path, queryParameters) => {
    const idToken = await getAuthenticatedIdToken();
    return API.get(this.apiName, path, {
      headers: {
        idt: idToken
      },
      queryStringParameters: {
        ...queryParameters,
        // idt: idToken
      }
    });
  }

  post = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    return API.post(this.apiName, path, {
      headers: {
        idt: idToken
      },
      queryStringParameters: {
        ...queryParameters,
        // idt: idToken
      },
      body: body
    })
  }

  patch = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    return API.patch(this.apiName, path, {
      headers: {
        idt: idToken
      },
      queryStringParameters: {
        ...queryParameters,
        // idt: idToken
      },
      body: body
    })
  }

  delete = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    return API.del(this.apiName, path, {
      headers: {
        idt: idToken
      },
      queryStringParameters: {
        ...queryParameters,
        // idt: idToken
      },
      body: body
    })
  }

  put = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    return API.put(this.apiName, path, {
      headers: {
        idt: idToken
      },
      queryStringParameters: {
        ...queryParameters,
        // idt: idToken
      },
      body: body
    })
  }

  /*
    Unsigned API actions
   */
  unsignedPut = (path, file, options) => {
    console.log(path);
    return axios.put(path, file, options);
  }

  /*
    Custom credentials for unauthenticated API actions
   */
  unauthenticatedGet = async (path, queryParameters) => {
    const endpoint = await API.endpoint(this.apiName);
    const signedHeader = sign(currentPublicSessionCredentials(),'GET', endpoint, path, queryParameters);
    return API.get(this.apiName, path, {
      headers: signedHeader,
      queryStringParameters: queryParameters
    });
  }

  unauthenticatedPost = async (path, queryParameters, body) => {
    const endpoint = await API.endpoint(this.apiName);
    const signedHeader = sign(currentPublicSessionCredentials(),'POST', endpoint, path, queryParameters, body);
    return API.post(this.apiName, path, {
      headers: signedHeader,
      queryStringParameters: queryParameters,
      body: body
    });
  }
}

export default Service;
